import React from 'react';
import { useTranslation } from 'react-i18next';
import OptionModal from '../../../../shared/components/OptionModal';
import ModalContentComponent from '../../../../shared/components/ModalContentComponent';

const ContentsOfCampaignModals = ({
  // delete content relation modal
  visibleModalDeleteContentRelation,
  showModalDeleteContentRelation,
  deleteContentOfListRelation,
  // clean progress modal
  visibleModalCleanContent,
  showModalCleanContent,
  cleanProgress,
  // clone name modal
  visibleModalCloneNameContent,
  cancelModalCloneNameContent,
  cloneNameToAllVersions,
  // view content modal
  visibleModalContent,
  cancelModalContent,
  contentModal
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalContentComponent
        visible={visibleModalContent}
        onCancel={cancelModalContent}
        content={contentModal}
      />

      <OptionModal
        title={t('Atention!')}
        body={t('Are you sure you want to delete this spot?')}
        visible={visibleModalDeleteContentRelation}
        okText={t('Continue')}
        cancelText={t('Cancel')}
        onOk={deleteContentOfListRelation}
        onCancel={showModalDeleteContentRelation}
        okButtonProps={{ loading: false }}
      />

      <OptionModal
        title={t('Atention!')}
        body={t(
          'Are you sure you want to delete all progress so far? It will remove the loaded ads and created relationships.'
        )}
        visible={visibleModalCleanContent}
        okText={t('Continue')}
        cancelText={t('Cancel')}
        onOk={cleanProgress}
        onCancel={showModalCleanContent}
        okButtonProps={{ loading: false }}
      />

      <OptionModal
        title={t('Atención!')}
        body={t(
          'You are about to clone this ad name to all other ads in the same version. This action will overwrite the current names.'
        )}
        visible={visibleModalCloneNameContent}
        okText={t('OK')}
        cancelText={t('Cancelar')}
        onOk={cloneNameToAllVersions}
        onCancel={cancelModalCloneNameContent}
        okButtonProps={{ loading: false }}
        width={600}
      />
    </>
  );
};

export default ContentsOfCampaignModals;
